module.exports = __webpack_public_path__ + "img/part1-3.df393c40.png";